import type { SearchInputProps } from "./SearchInput";
import { SearchInput } from "./SearchInput";

export interface SelectedItem {
  text: string;
  value: string;
}

export interface SingleSelectInputProps extends SearchInputProps {
  open: boolean;
  selectedItems: SelectedItem[];
}

export const SingleSelectInput = (props: SingleSelectInputProps) => {
  const { selectedItems, open: isOpen, handleOpen } = props;
  const selectedItem = selectedItems[0];

  if (isOpen || !selectedItem) {
    return <SearchInput {...props} />;
  }

  return (
    <button
      type="button"
      onClick={handleOpen}
      className="flex w-full items-center text-base leading-6 disabled:cursor-not-allowed disabled:opacity-50"
    >
      {selectedItem.text}
    </button>
  );
};
